var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHalfcourt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 537,
    height: 452,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-436 -312)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M952.409 405.462 1456.98 405.462 1456.98 852.078 952.409 852.078Z",
    stroke: "#F2F2F2",
    strokeWidth: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "nonzero",
    transform: "matrix(1.0551 0 0 1 -566.057 -89.7829)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.283 316.021 1089.93 316.021 1089.93 735.498 636.283 735.498Z",
    stroke: "#000000",
    strokeWidth: 5.24033,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "nonzero",
    transform: "matrix(1.06279 0 0 1 -212.295 26.3822)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 0.168651 101.233",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1.06279 0 0 -1 498.253 444.815)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.96 415.249 1057.88 316.964",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1.06279 0 0 1 -212.295 26.3822)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.19 413.858C1039.27 525.447 936.643 600.008 828.966 580.4 748.134 565.679 684.448 500.797 668.868 417.294",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1.06279 0 0 1 -212.295 26.3822)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.464 316.258 935.572 316.258 935.572 503.841 789.464 503.841Z",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "nonzero",
    transform: "matrix(1.06279 0 0 1 -212.295 26.3822)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.103 365.157 789.369 365.157",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1.06279 0 0 1 -212.295 26.3822)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.103 431.847 789.423 431.847",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1.06279 0 0 1 -212.295 26.3822)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.103 459.657 789.423 459.657",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1.06279 0 0 1 -212.295 26.3822)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 4.26645 8.50481e-05",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(-1.06279 0 0 1 786.682 391.538)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M935.691 431.847 939.955 431.847",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1.06279 0 0 1 -212.295 26.3822)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 4.26645 8.50481e-05",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(-1.06279 0 0 1 786.432 486.038)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.811 391.549 789.817 391.549 789.817 404.982 785.811 404.982Z",
    stroke: "#000000",
    strokeWidth: 0.7,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "nonzero",
    transform: "matrix(1.06279 0 0 1 -212.295 26.3822)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 3.77053 0 3.77053 13.4327-6.40069e-08 13.4327Z",
    stroke: "#000000",
    strokeWidth: 0.7,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "nonzero",
    transform: "matrix(-1.06279 0 0 1 786.155 417.933)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.107 364.445C902.319 384.616 884.924 401.129 863.256 401.327 841.587 401.526 823.849 385.332 823.638 365.161 823.635 364.947 823.635 364.733 823.635 364.519",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1.06279 0 0 1 -212.295 26.3822)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.475 735.856C811.556 706.592 835.682 683.764 864.359 684.867 891.516 685.914 913.299 708.136 914.325 735.848",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1.06279 0 0 1 -212.295 26.3822)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.597 503.106C914.807 532.063 891.711 555.711 863.012 555.921 834.313 556.133 810.877 532.83 810.668 503.873 810.665 503.617 810.665 503.367 810.668 503.111",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1.06279 0 0 1 -212.295 26.3822)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 0.108011 13.4531",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1.06279 0 0 -1 662.804 391.207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 0.108011 13.4531",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1.06279 0 0 -1 746.458 391.443)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfcourt);
export default __webpack_public_path__ + "static/media/halfcourt.bf02847e3d4bbc21d572188b3c933bee.svg";
export { ForwardRef as ReactComponent };